import { useNavigate } from "react-router-dom";
import useAuth from "../../../../hook/useAuth";
import { useState } from "react";
import { PleasewaitPopup } from "../../../../components/PleasewaitPopup";
import axios from "axios";
import { baseURL } from "../../../../config/api";

export const AddTireBrand = () => {
    const navigate = useNavigate();
    const { auth }: any = useAuth();
    const [brandName, setBrandName] = useState<string>("");
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setPleaseWaitPopup(true);
        await axios
            .post(
                `${baseURL}tireBrands?userId=${auth?.id}`,
                JSON.stringify({
                    brandName,
                }),
                {
                    headers: { "Content-Type": "application/json" },
                    withCredentials: false,
                }
            )
            .then((response) => {
                setPleaseWaitPopup(false);
                navigate(-1);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);
                console.error("Error:", error);
            });
    }

    return (
        <>
            <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
                <div className="w-full bg-white p-4 rounded-md">
                    <h2 className={`text-lg font-semibold`}>Add Brand</h2>

                    <div className="mt-2 p-2">
                        <form onSubmit={(e) => handleSubmit(e)}>
                            <div className="w-full">
                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-6">
                                    {/* First Column */}
                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Brand Name</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={brandName}
                                                placeholder="Brand Name"
                                                onChange={(e) => setBrandName(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Buttons */}
                                <div className="flex flex-col sm:flex-row gap-4 mt-6">
                                    <button
                                        type="submit"
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                    >
                                        Save
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => navigate(-1)}
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-[#FFFFFF] text-primary cursor-pointer border border-primary"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <PleasewaitPopup showPopup={pleaseWaitPopup} />
        </>
    )
}